import React from 'react';
import { observer } from 'mobx-react';
import { resourcePath } from '../../../utils/helpers';
import { FlexDiv, Image } from '../../design-system/containers';

function EmailAttachment({
    isHoveringOnAttachment,
    attachment,
    t,
    handleAttachmentClick,
    handleAttachmentMouseEnter,
    handleAttachmentMouseLeave,
}) {
    return (
        <FlexDiv pt={24}>
            <Image
                width={180}
                link
                src={resourcePath(
                    isHoveringOnAttachment
                        ? attachment.iconHover
                        : attachment.icon
                )}
                alt={t(attachment.text)}
                onClick={handleAttachmentClick}
                onMouseEnter={handleAttachmentMouseEnter}
                onMouseLeave={handleAttachmentMouseLeave}
            />
        </FlexDiv>
    );
}

export default observer(EmailAttachment);
